import axios from 'axios';
const apiUrl = process.env.REACT_APP_FIREBASE_FUNCTIONS_URL as string;

export async function hasAzureAuthUserService(args: {
  userId: string;
}): Promise<boolean> {
	try {
		const response = await axios.get(`${apiUrl}/auth/${args.userId}`, {
			headers: {
				'Content-Type': 'application/json'
			}
		});
  
		return response.status === 204;
	} catch (err) {
		if (axios.isAxiosError(err) && err.response?.status === 404) {
			return false;
		}

		throw new Error('Get automation rule list service.');
	}
}